import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './../api/api.service';
import { IDwellingInput } from './../../models/dwellingInput.interface';
import { IDwellingDetectionReturned } from '../../models/dwellingdetection.interface';
import { Dictionary, update } from 'lodash';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class quizService {

  constructor(private http: ApiService) { }

  public getrefreshQuiz(isess:boolean,isemr:boolean): Observable<any> {
   

    var nounce = new Date();

      return this.http.get(`/quiz/quiz?isess=${isess}&isemr=${isemr}`)
      .pipe(map(res => res as any));
    }
  
  public updateQuizStatus(quizId:Number,result:boolean,isess:boolean,isemr:boolean): Observable<any> {
   
    const headers = new HttpHeaders();
    headers.append('withCredentials', 'true');
    return this.http.post(`/quiz/quiz?quizId=${quizId}&result=${result}&isess=${isess}&isemr=${isemr}`,  { headers });
  }
  }
  
